import React from "react";
import { Breadcrumb } from "react-bootstrap";
import MasterLayout from "../../masterLayout/MasterLayout";
import PostLayer from "./PostLayer";

const PostPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Components / Posts" />
      <PostLayer />
    </MasterLayout>
  );
};

export default PostPage;
